<template>
  <div class="product-eval-settings" />
</template>

<script>

/**
 * Vue: product-eval-settings (product-eval-settings)
 * -----------------------------------------------------------------------------
 * Settings for product evaluation copy.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'ProductEvalSettings',

  props: {
    initialData: {
      type: Object,
      default: null,
    },
    confirmationData: {
      type: Object,
      default: null,
    },
    successData: {
      type: Object,
      default: null,
    },
    blockedData: {
      type: Object,
      default: null,
    },
    errorData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  mounted() {
    this.setInitialData(this.initialData)
    this.setConfirmationData(this.confirmationData)
    this.setSuccessData(this.successData)
    this.setBlockedData(this.blockedData)
    this.setErrorData(this.errorData)
    // set async component data here
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      setInitialData: 'product-eval-copy/setInitialData',
      setConfirmationData: 'product-eval-copy/setConfirmationData',
      setSuccessData: 'product-eval-copy/setSuccessData',
      setBlockedData: 'product-eval-copy/setBlockedData',
      setErrorData: 'product-eval-copy/setErrorData',
    }),
  },
}
</script>
